import { Helmet } from 'react-helmet'

export default () =>
  <Helmet>
    <meta name='prerender-status-code' content='404' />
  </Helmet>
